/**
 * support コンポーネント専用i18n定数
 */

export const SUPPORT_I18N = {
  // ツールバー
  toolbar: {
    title: $localize`:@@home.support.toolbar.title:サポート`,
  },

  // サブタイトル
  subtitle: $localize`:@@home.support.subtitle:こちらのお問い合わせ先フォームは、運営管理会社に送信されます。`,

  // スナックバーメッセージ
  snackBar: {
    success: $localize`:@@home.support.snackBar.success:メッセージを送信しました。受信完了通知メールがない場合には再度ご連絡頂ますようお願いいたします。`,
    error: $localize`:@@home.support.snackBar.error:メッセージの送信に失敗しました。再度ネットワーク環境をご確認の上お試しください。`,
    close: $localize`:@@home.support.snackBar.close:閉じる`,
  },
} as const;

export type SupportI18n = typeof SUPPORT_I18N;
